import React, { useState } from 'react';
import Icon from '@mdi/react';
import { mdiAlert, mdiCloseCircle } from '@mdi/js';
import BaseModal from './BaseModal';
import './RejectionModal.css';

const RejectionModal = ({ booking, onClose, onConfirm }) => {
  const [rejectionReason, setRejectionReason] = useState(
    'Sorry, I am no longer available at that time.'
  );
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      await onConfirm(booking.id, rejectionReason);
      onClose();
    } catch (error) {
      console.error('Error rejecting booking:', error);
      setIsSubmitting(false);
    }
  };

  return (
    <BaseModal
      isOpen
      onClose={onClose}
      title="Reject Booking Request?"
      icon={mdiCloseCircle}
      iconColor="#ef4444"
      maxWidth={600}
      className="rejection-modal-context"
      footer={
        <>
          <button
            className="base-modal-cancel-btn"
            onClick={onClose}
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button
            className="base-modal-save-btn rejection-confirm-btn"
            onClick={handleSubmit}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Rejecting...' : 'Reject Booking'}
          </button>
        </>
      }
    >
      <div className="rejection-warning">
        <Icon path={mdiAlert} size={1} className="rejection-warning-icon" />
        <div className="rejection-warning-content">
          <p className="rejection-warning-title">
            IMPORTANT: You don't have to reject!
          </p>
          <p className="rejection-warning-text">
            Rejection is for change of circumstances like sickness or change of availability;
            alternately you can message student to check for another time availability,
            and then edit the booking.
          </p>
        </div>
      </div>

      <div className="rejection-booking-info">
        <p><strong>Student:</strong> {booking?.studentName || 'Unknown'}</p>
        <p><strong>Time:</strong> {booking?.timeSlot?.startTime} - {booking?.timeSlot?.endTime}</p>
        <p><strong>Date:</strong> {new Date(booking?.bookingDate).toLocaleDateString()}</p>
      </div>

      <div className="rejection-reason-section">
        <label htmlFor="rejection-reason" className="rejection-reason-label">
          Rejection Message
        </label>
        <p className="rejection-form-hint">
          This message will be sent to the student. You can edit or send as written.
        </p>
        <textarea
          id="rejection-reason"
          className="rejection-reason-textarea"
          placeholder="Sorry, I am no longer available at that time..."
          value={rejectionReason}
          onChange={(e) => setRejectionReason(e.target.value)}
          rows={4}
          disabled={isSubmitting}
        />
      </div>
    </BaseModal>
  );
};

export default RejectionModal;
